import { useContext, createContext } from 'react';

const IsInsideIsolatedDcAppContext = createContext(false);

export const IsInsideIsolatedDcAppProvider = IsInsideIsolatedDcAppContext.Provider;

export function useIsInsideIsolatedDcApp() {
  return useContext(IsInsideIsolatedDcAppContext);
}
